import posthog from 'posthog-js';

/** Unconditionally resets PostHog; logout resets via the login-mount check. */
export function resetPosthog() {
  if (typeof window !== 'undefined') {
    posthog.reset();
  }
}
